/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { Dimensions, Platform } from 'react-native';
import { Orientation } from '@airasia-phoenix/react-native/utils/utils';

const CARD_WIDTH_TO_SCREEN_DIVISOR = 1.2;
const BASE_HORIZONTAL_SPACING = 12;
const SPACING_ADJUSTMENT_FACTOR = 2.5;

const Constants = {
  IMAGE_HEIGHT: 72,
  IMAGE_WIDTH: 72,
  get CARD_WIDTH() {
    // Web: Fixed width (312px) so multiple cards fit
    if (Platform.OS === 'web') {
      return 312;
    }
    // Match Hotel implementation: screenWidth / 1.2
    const screenWidth = Dimensions.get('window').width;
    return screenWidth / CARD_WIDTH_TO_SCREEN_DIVISOR;
  },
  INITIAL_LOAD_COUNT: 5,
  SUBSEQUENT_LOAD_COUNT: 2,
  PRIMARY_TEXT: '{0} to {1}',
  CAROUSEL_HEIGHT: 100,
  get CAROUSEL_ORIENTATION() {
    // Match Hotel horizontal spacing: 12 / 2.5
    const horizontalSpacingInCards =
      BASE_HORIZONTAL_SPACING / SPACING_ADJUSTMENT_FACTOR;
    const rowCount = 1;
    return new Orientation.Horizontal(0, rowCount, horizontalSpacingInCards, 0);
  },
  SCROLL_SPEED: 0.85,
  // Destination image URL pattern – same CDN as flights package
  // {0} is replaced with lowercase destination station code (e.g. "bkk")
  DEST_IMAGE_URL:
    'https://static.airasia.com/design/images/destination/ds-{0}-med.jpg',
  // Fallback when destination image fails to load
  PLACEHOLDER_IMAGE:
    'https://static.airasia.com/mobile/phoenix/icons/v1/main/svg/image/image.svg',
};

export default Constants;
